// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyMessages_wrap__oQUCF"};